const partners = {
  ENVIOS_NOW: 'envios now',
  FAZT: 'fazt',
  STGO_COURIER: 'stgo courier'
}

const partnerLabels = {
  ENVIOS_NOW: 'Envios Now',
  FAZT: 'Fazt',
  STGO_COURIER: 'Stgo Courier'
}

const partnerSelectOptions = [
  { text: partnerLabels.ENVIOS_NOW, value: partners.ENVIOS_NOW },
  { text: partnerLabels.FAZT, value: partners.FAZT },
  { text: partnerLabels.STGO_COURIER, value: partners.STGO_COURIER }
]

const partnerDeliveryStatusLabels = {
  [partners.ENVIOS_NOW]: {
    pendiente: 'Pendiente',
    'por entregar': 'Por Entregar',
    entregado: 'Entregado',
    rechazado: 'Rechazado',
    cancelado: 'Cancelado'
  },
  [partners.FAZT]: {
    'Sin comuna': 'Sin comuna',
    Creado: 'Creado',
    'Etiqueta impresa': 'Etiqueta impresa',
    'En deposito': 'En deposito',
    'En ruta': 'En ruta',
    Completado: 'Completado',
    'No completado': 'No completado',
    Cancelado: 'Cancelado',
    Duplicado: 'Duplicado',
    'No aceptado': 'No aceptado',
    Siniestrado: 'Siniestrado',
    'En Devolución': 'En Devolución',
    Devuelto: 'Devuelto',
    'No Devuelto': 'No Devuelto',
    Retirado: 'Retirado'
  },
  [partners.STGO_COURIER]: {
    '0': 'Retirado',
    '1': 'A planta',
    '2': 'En camino',
    '3': 'Devolviendo a planta de procesamiento',
    '5': 'Entregado',
    '6': 'Nadie',
    '7': 'A retirar',
    '8': 'Cancelado',
    '9': 'Entregado 2DA visita',
    '10': 'Nadie 2DA visita',
    '11': 'En camino 2da visita',
    '13': 'No entregado'
  }
}

export default {
  partners,
  partnerLabels,
  partnerSelectOptions,
  partnerDeliveryStatusLabels
}
